







































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { Mutation, Action } from 'vuex-module-decorators';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import GSurveyAnalyzeFilter from '@/views/GSurveyAnalyze/GSurveyAnalyzeFilter.vue';
import GSurveyChart from '@/views/GSurveyAnalyze/GSurveyChart.vue';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import GLoading from '@/components/GLoading.vue';
import GStatisticsBoxplotSubTableInfoTable from '@/components/GStatisticsBoxplotSubTableInfoTable.vue';
import { SurveyAnalysisTabelMapping } from '@/models/jgrow/survey-analysis-tabel-mapping';
import GOptionalData from '@/components/GOptionalData.vue';
import { ActiveEntryMatrix, MetaAwarenessGrowthQuestion } from '@/models/jgrow/survey-answer';
import { Activity } from '@/models/activity/activity';

@Component({
  name: 'GSurveyCompetencyPlusGrowthAnalyze',
  components: {
    GLoading,
    GSurveyChart,
    GSurveyAnalyzeFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GOptionalData,
    GStatisticsBoxplotSubTableInfoTable,
  },
  computed: {},
  methods: {},
})
export default class GSurveyCompetencyPlusGrowthAnalyze extends mixins(GPageBase) {
  expectedAllMap: Map<number, Array<number>> = new Map();
  expectedPushyMap: Map<number, Array<number>> = new Map();
  expectedActiveMap: Map<number, Array<number>> = new Map();
  unexpectedAllMap: Map<number, Array<number>> = new Map();
  unexpectedPushyMap: Map<number, Array<number>> = new Map();
  unexpectedActiveMap: Map<number, Array<number>> = new Map();
  activeAnswerRateMap: Map<number, Array<number>> = new Map();
  aggresiveMap: Map<number, ActiveEntryMatrix[]> = new Map();

  async mounted() {}

  get total(): number {
    return surveyAnalyzeModule.totalUser;
  }

  get metaAwarenessGrowthQuestions(): MetaAwarenessGrowthQuestion[] {
    return surveyAnalyzeModule.metaAwarenessGrowthQuestions;
  }

  get activities(): Activity[] {
    return surveyAnalyzeModule.activities;
  }

  @Mutation
  setAggresiveMap(value: Map<number, ActiveEntryMatrix[]>) {
    this.aggresiveMap = value;

    this.aggresiveMap.forEach((matricis: ActiveEntryMatrix[]) => {
      matricis.sort((a, b) => {
        return a.competencyID - b.competencyID;
      });
    });
  }

  getCompetencyName(id: number): string {
    return surveyAnalyzeModule.competencyNameMap.get(id);
  }

  getActivityName(id: number): string {
    return surveyAnalyzeModule.activityNameMap.get(id);
  }

  getAnalysisSelectMapActivity(competencyID: number, index: number): SurveyAnalysisTabelMapping {
    return this.surveyAnalysisSelectTabelMap.get(competencyID)[index];
  }

  getActiveTotalRate(matrix: ActiveEntryMatrix): number {
    return Math.floor((this.getTotal(matrix) / matrix.availableTotal) * 100 * 10) / 10;
  }

  get surveyAnalysisSelectTabelMap(): Map<number, SurveyAnalysisTabelMapping[]> {
    return surveyAnalyzeModule.surveyAnalysisSelectTabelMap;
  }

  get activeEntryMatrices(): ActiveEntryMatrix[] {
    return surveyAnalyzeModule.activeEntryMatrices;
  }

  getPercetage(matrix: ActiveEntryMatrix, count: number) {
    return Math.floor((count / this.getTotal(matrix)) * 100 * 10) / 10;
  }

  getTotal(matrix: ActiveEntryMatrix): number {
    return matrix.underUnder + matrix.underOver + matrix.overUnder + matrix.overOver;
  }

  getActivityLabel(competencyID: number, index: number): string {
    return this.surveyAnalysisSelectTabelMap.get(competencyID) && this.getAnalysisSelectMapActivity(competencyID, index)
      ? this.getActivityName(this.getAnalysisSelectMapActivity(competencyID, index).id) + ' (' + this.getAnalysisSelectMapActivity(competencyID, index).pointList[0].items + ')'
      : '';
  }

  getColLength(activityID: number): number {
    return this.aggresiveMap.get(activityID).length;
  }

  getSymbolPercent(n: number): string {
    return n % 2 === 0 ? '' : ' %';
  }

  @Mutation
  setExpectedAllMap(value: Map<number, Array<number>>) {
    this.expectedAllMap = value;
  }

  @Mutation
  setExpectedPushyMap(value: Map<number, Array<number>>) {
    this.expectedPushyMap = value;
  }

  @Mutation
  setExpectedActiveMap(value: Map<number, Array<number>>) {
    this.expectedActiveMap = value;
  }

  @Mutation
  setUnexpectedAllMap(value: Map<number, Array<number>>) {
    this.unexpectedAllMap = value;
  }

  @Mutation
  setUnexpectedActiveMap(value: Map<number, Array<number>>) {
    this.unexpectedActiveMap = value;
  }

  @Mutation
  setUnexpectedPushyMap(value: Map<number, Array<number>>) {
    this.unexpectedPushyMap = value;
  }

  @Mutation
  setActiveAnswerRateMap(value: Map<number, Array<number>>) {
    this.activeAnswerRateMap = value;
  }

  @Action({ rawError: true })
  setDataList() {
    const expectedAllMap: Map<number, Array<number>> = new Map();
    const expectedPushyMap: Map<number, Array<number>> = new Map();
    const expectedActiveMap: Map<number, Array<number>> = new Map();
    const unexpectedAllMap: Map<number, Array<number>> = new Map();
    const unexpectedActiveMap: Map<number, Array<number>> = new Map();
    const unexpectedPushyMap: Map<number, Array<number>> = new Map();
    const activeAnswerRateMap: Map<number, Array<number>> = new Map();
    this.setAggresiveMap(surveyAnalyzeModule.competencyPlusMatrixMap);

    this.activities.map((a: Activity) => {
      const expectedAll: Array<number> = new Array();
      const expectedPushy: Array<number> = new Array();
      const expectedActive: Array<number> = new Array();
      const unexpectedAll: Array<number> = new Array();
      const unexpectedPushy: Array<number> = new Array();
      const unexpectedActive: Array<number> = new Array();
      const activeAnswerRate: Array<number> = new Array();

      if (this.aggresiveMap.get(a.activityID)) {
        this.aggresiveMap.get(a.activityID).map((matrix: ActiveEntryMatrix, i) => {
          expectedAll.push(matrix.underUnder + matrix.underOver);
          expectedAll.push(this.getPercetage(matrix, matrix.underUnder + matrix.underOver));
          expectedPushy.push(matrix.underUnder);
          expectedPushy.push(this.getPercetage(matrix, matrix.underUnder));
          expectedActive.push(matrix.underOver);
          expectedActive.push(this.getPercetage(matrix, matrix.underOver));
          unexpectedAll.push(matrix.overUnder + matrix.overOver);
          unexpectedAll.push(this.getPercetage(matrix, matrix.overUnder + matrix.overOver));
          unexpectedPushy.push(matrix.overUnder);
          unexpectedPushy.push(this.getPercetage(matrix, matrix.overUnder));
          unexpectedActive.push(matrix.overOver);
          unexpectedActive.push(this.getPercetage(matrix, matrix.overOver));
          activeAnswerRate.push(this.getActiveTotalRate(matrix));
        });

        expectedAllMap.set(a.activityID, expectedAll);
        expectedPushyMap.set(a.activityID, expectedPushy);
        expectedActiveMap.set(a.activityID, expectedActive);
        unexpectedAllMap.set(a.activityID, unexpectedAll);
        unexpectedActiveMap.set(a.activityID, unexpectedActive);
        unexpectedPushyMap.set(a.activityID, unexpectedPushy);
        activeAnswerRateMap.set(a.activityID, activeAnswerRate);
      }
    });
    this.setExpectedAllMap(expectedAllMap);
    this.setExpectedPushyMap(expectedPushyMap);
    this.setExpectedActiveMap(expectedActiveMap);
    this.setUnexpectedAllMap(unexpectedAllMap);
    this.setUnexpectedActiveMap(unexpectedActiveMap);
    this.setUnexpectedPushyMap(unexpectedPushyMap);
    this.setActiveAnswerRateMap(activeAnswerRateMap);
  }
}
